import {PersistenceDecoratorOptions} from "./persistence-decorator-options.interface";
import {Repository} from "../persistence/repository";
import {container} from "tsyringe";
import {EntityManager} from "../persistence/entity.manager";
import {ClassOf} from "../types/class-of.type";
import {PersistencePreloader} from "../persistence/persistence.preloader";

export function persistence(options?: PersistenceDecoratorOptions) {

    return function (constructor: ClassOf<Repository<any>>) {
        const entityManager = container.resolve(EntityManager);
        constructor.prototype._entityManager = entityManager;

        if (!options) {
            return;
        }

        if (options.entity) {
            entityManager.registerRepositoryForEntity(options.entity, constructor);
            constructor.prototype._entityType = options.entity;

            if (options.preload) {
                container.resolve(PersistencePreloader).registerForPreload(constructor);
            }
        }

    }
}